import React from 'react';
import { Typography, AppBar, Toolbar, Stack, Box } from '@mui/material';

const Title = ({menuButton,children}) => {
	return(
		<AppBar position={menuButton?"fixed":"static"}>
			<Toolbar disableGutters>
				<Stack direction="row" justifyContent="space-between" alignItems="center" flexGrow="0.8">
					<Stack spacing={0} direction="row" alignItems="center">
						{menuButton}
						<Box
							component="img"
							src="/android-chrome-512x512.png"
							sx={{
								height: {lg:50,md:40,xs:30},
								width: {lg:50,md:40,xs:30},
								margin: {sm:2,xs:1},
							}}
							/>
						<Typography variant="h1">Romiley Poker League</Typography>
					</Stack>
					{children.length>0 &&
						<Stack direction="row" spacing={{xs:0}} height="50%" alignItems="flex-end" justifyContent="space-between">
							{children}
						</Stack>
					}
				</Stack>
			</Toolbar>
		</AppBar>
	)
}

export default Title;